import React, { useState } from "react";
import JoinusModel from "../../components/JoinusModel";

const SupportMission = () => {
    const [isJoinUsModelOpen,setIsJoinUsModelOpen] = useState(false);
    function joinUs() {
        setIsJoinUsModelOpen(true);
    }
    return (
        <div id="support-us" className="bg-darkBlue">
            <div className="px-20px max-w-[1100px] mx-auto text-center lg-xl:py-20 lg:py-15 py-10">
                <h2 className="font-bold lg-xl:text-[50px] lg-xl:leading-[65px] lg:text-[40px] lg:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] text-customRed tracking-normal uppercase font-fira pb-2.5">
                    SUPPORT OUR MISSION
                </h2>

                <p className="text-white lg:text-[26px] lg:leading-[41.6px] text-[20px] leading-[26px] font-normal tracking-normal font-fira pb-[30px]">
                    <span className="text-customRed font-semibold underline cursor-pointer" onClick={joinUs}>JOIN US</span> in shaping Houston's future! Your donation to Fired Up To Vote empowers us to connect
                    with voters and ensure their voices are heard in local and general elections. Every contribution
                    helps us recruit and train dedicated volunteers to achieve our goal of reaching <span className="text-customRed font-semibold">150,000 voters</span> in
                    Harris County. Together, we can build a more informed and engaged community.
                </p>

                <div className="mx-auto max-w-[300px]">
                    <a
                        href="https://givebutter.com/2PSZC5"
                        target="blank"
                        className="bg-customRed py-[14px] p-30px flex justify-center text-white lg:text-22px lg:leading-[23.4px] text-18px leading-[24px] font-medium tracking-normal font-fira uppercase max-w-[300px] hover:bg-darkRed"
                    >
                        <span className="pr-20px">DONATE ONLINE</span>
                        <img src="/arrow_forward.svg" alt="arrow" />
                    </a>
                    <div className="text-white lg:text-[26px] lg:leading-[41.6px] text-[20px] leading-[26px] font-normal tracking-normal font-fira pt-[30px]">OR</div>
                    <div className="text-white lg:text-[26px] lg:leading-[41.6px] text-[20px] leading-[26px] font-normal tracking-normal font-fira pt-[30px]">
                        <div>DONATE BY CHECK </div>
                        <div>MAKE CHECK PAYABLE TO FIRED UP TO VOTE</div>
                    </div>
                    <div className="text-white lg:text-[26px] lg:leading-[41.6px] text-[20px] leading-[26px] font-normal tracking-normal font-fira pt-[15px]">
                        <div>MAIL TO: FIRED UP TO VOTE</div>
                        <div>675 Bering Dr. Ste 200</div>
                        <div>Houston, TX 77056</div>
                    </div>
                </div>
            </div>
            {isJoinUsModelOpen && <JoinusModel closeModel={()=> setIsJoinUsModelOpen(false)}/> }
        </div>
    );
};

export default SupportMission;